import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const colorMap: Record<string, string> = {
  primary: 'from-primary-500/8 to-primary-500/3 border-primary-200/40 hover:border-primary-300',
  accent: 'from-accent-500/8 to-accent-500/3 border-accent-200/40 hover:border-accent-300',
  secondary: 'from-secondary-500/8 to-secondary-500/3 border-secondary-200/40 hover:border-secondary-300',
};

const iconColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600',
  accent: 'bg-accent-100 text-accent-600',
  secondary: 'bg-secondary-100 text-secondary-600',
};

export default function CategoriesSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              探索<span className="text-primary-600">服务分类</span>
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              六大核心服务模块，满足您的多样化需求
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {categories.map((category) => (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className={`group p-6 md:p-7 rounded-2xl bg-gradient-to-br border transition-all duration-300 cursor-pointer ${colorMap[category.color] || colorMap.primary}`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 group-hover:scale-110 transition-transform duration-300 ${iconColorMap[category.color] || iconColorMap.primary}`}>
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">{category.name}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">{category.description}</p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:gap-2 transition-all duration-200">
                  了解更多 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}